import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://mpefixbwfugmngwyjuus.supabase.co"
const anonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1wZWZpeGJ3ZnVnbW5nd3lqdXVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDM4ODY2NDYsImV4cCI6MjAxOTQ2MjY0Nn0.anTdewlp4vBDmEVXuOiS9XZDplIN60wkeFqD0DCYykk"
const supabase = createClient(supabaseUrl, anonKey)

export default supabase;